import { useEffect } from "react";
import { isAutoMode, applyAutoTheme } from "@/lib/theme";

// Headless controller: while the user hasn't explicitly picked light/dark, it
// switches the map/app to dark automatically at sunset (and back at sunrise),
// based on the device's real position when available. Re-checks every 10 min.
export function AutoNightTheme() {
  useEffect(() => {
    if (!isAutoMode()) return undefined;

    const coords = { lat: 46.6, lon: 2.4 }; // France centre fallback
    const apply = () => {
      if (isAutoMode()) applyAutoTheme(coords.lat, coords.lon);
    };

    apply();

    // Refine with the real position (one-shot, non-blocking, coarse accuracy).
    if (typeof navigator !== "undefined" && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          coords.lat = pos.coords.latitude;
          coords.lon = pos.coords.longitude;
          apply();
        },
        (err) => { console.debug("Mode nuit auto: position indisponible", err); },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
      );
    }

    const id = setInterval(apply, 10 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return null;
}
